import { LessonAttendancePlain } from 'src/api/endpoints/attendance/attendance.types'
import { AttendanceLesson } from 'src/@types/modules/attendance/attendance.types'
import { map } from 'lodash'

export const lessonAttendanceTransformer = (plainLessons: LessonAttendancePlain[]): AttendanceLesson[] => {
    return map(plainLessons, (plainLesson: LessonAttendancePlain): AttendanceLesson => ({
        ...plainLesson,
        status: plainLesson.status.id,
    }))
}